<script lang="ts" setup>
import type { PropType } from 'vue'
import LFDDisplay from './LFDDisplay.vue'
import type { LineImportStatus } from '~/models/lineImportStatus'
import type { Container } from '~/models/containers'
import { getTerminalLabel } from '~/constants'
import { useShippingLine } from '~/compositions/useShippingLines'
import { shortenContainerType } from '~/utils'

const props = defineProps({
  status: { type: Object as PropType<LineImportStatus>, required: true },
  container: { type: Object as PropType<Container>, required: true },
})

const { getShippingLine } = useShippingLine()

const StatusWithTimes = computed(() => ({
  ...props.status,
  last_observed: props.status?.last_observed ?? null,
  last_observed_changed: props.status?.observed ?? null,
}))
</script>

<template>
  <div class="mb-1">
    <ObjectChangeTimesDisplay :object="StatusWithTimes" />
    <RefreshShippingLineButton :line-status="props.status" class="ml-2" />
  </div>

  <el-descriptions border class="flex-1" :column="1">
    <el-descriptions-item label="Status">
      <template v-if="props.status">
        {{ props.status.statusDescription }} ({{ props.status.status }})
      </template>
      <template v-else> – </template>
    </el-descriptions-item>
    <el-descriptions-item label="Last Free Day">
      <LFDDisplay
        :last-free-date="props.status?.last_free_day ?? null"
        :unique-date-count="props.container.uniqueDateCount"
        :info="props.container.lfdInfo"
      />
    </el-descriptions-item>
    <el-descriptions-item v-if="props.status" label="Shipping Line">
      {{
        getShippingLine(props.status.parsed_shipping_line ?? undefined)
          ?.short_desc ?? 'N/A'
      }}
    </el-descriptions-item>
    <el-descriptions-item label="Container Type">
      {{
        shortenContainerType(
          props.status?.parsed_container_type ?? undefined
        ) ?? 'N/A'
      }}
    </el-descriptions-item>
    <el-descriptions-item label="Terminal">
      {{ getTerminalLabel(props.status?.terminal) ?? 'N/A' }}
    </el-descriptions-item>
  </el-descriptions>
</template>
